module.exports = __webpack_public_path__ + "img/zs_10@2x.28aa4f42.png";